import * as TagsActions from './tags.actions';

export { reducer as tagsReducer, tagsFeatureKey, TagsStore, TagsState } from './tags.reducer';
export { TagsActions };
export * from './tags.effects';
